import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import CheckAvailability from './components/CheckAvailability';
import CheckAvailabilityModal from './components/CheckAvailabiltyModal';


if (document.getElementById('checkAvailability')) {
  const checkAvailability = ReactDOM.createRoot(
    document.getElementById('checkAvailability') as HTMLElement
  );
  checkAvailability.render(
    <React.StrictMode>
      <div className="twp">
        <CheckAvailability />
      </div>
    </React.StrictMode>
  );
}

if (document.getElementById('checkAvailabilityModal')) {
  const checkAvailabilityModal = ReactDOM.createRoot(
    document.getElementById('checkAvailabilityModal') as HTMLElement
  );
  checkAvailabilityModal.render(
    <React.StrictMode>
      <div className="twp">
        <CheckAvailabilityModal />
      </div>
    </React.StrictMode>
  );
}

const divs=Array.from(document.querySelectorAll('[data-checkAvailabilityModal]'))
if(divs.length){
  divs.forEach((rte)=>{
    const checkAvailabilityModal = ReactDOM.createRoot(
      rte as HTMLElement
    );
    checkAvailabilityModal.render(
      <React.StrictMode>
        <div className="twp">
          <CheckAvailabilityModal />
        </div>
      </React.StrictMode>
    );
  })

}

// Measure app performance if needed
reportWebVitals();
